import React, { useState } from 'react';
import { X } from 'lucide-react';

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);

  const categories = [
    { id: 'all', label: 'Todos' },
    { id: 'sacadas', label: 'Sacadas' },
    { id: 'boxes', label: 'Boxes' },
    { id: 'espelhos', label: 'Espelhos' },
    { id: 'portas', label: 'Portas e Divisórias' },
  ];

  const galleryImages = [
    // Sacadas
    { id: 1, src: '/assets/images/hero-sacada.jpg', category: 'sacadas', alt: 'Sacada envidraçada com perfil preto' },
    { id: 2, src: '/assets/images/sacada-1.jpg', category: 'sacadas', alt: 'Envidraçamento de sacada moderno' },
    { id: 3, src: '/assets/images/sacada-3.jpg', category: 'sacadas', alt: 'Sacada com vidro frameless' },
    { id: 4, src: '/assets/images/sacada-4.jpg', category: 'sacadas', alt: 'Vista interna sacada envidraçada' },
    { id: 5, src: '/assets/images/sacada-5.jpg', category: 'sacadas', alt: 'Sacada com acabamento premium' },
    { id: 6, src: '/assets/images/sacada-6.jpg', category: 'sacadas', alt: 'Envidraçamento completo de varanda' },
    { id: 7, src: '/assets/images/area-gourmet-1.png', category: 'sacadas', alt: 'Área gourmet com vidro preto' },
    { id: 8, src: '/assets/images/area-gourmet-2.png', category: 'sacadas', alt: 'Fechamento de área externa' },
    
    // Boxes
    { id: 9, src: '/assets/images/box-1.jpg', category: 'boxes', alt: 'Box de banheiro com perfil preto' },
    { id: 10, src: '/assets/images/box-2.jpg', category: 'boxes', alt: 'Box para banheiro grande' },
    { id: 11, src: '/assets/images/box-3.jpg', category: 'boxes', alt: 'Box com perfil dourado premium' },
    { id: 12, src: '/assets/images/box-4.jpg', category: 'boxes', alt: 'Box preto com banheira de imersão' },
    { id: 13, src: '/assets/images/box-5.png', category: 'boxes', alt: 'Box estilo industrial' },
    { id: 14, src: '/assets/images/box-6.png', category: 'boxes', alt: 'Box com vidro jateado' },
    { id: 15, src: '/assets/images/box-7.jpg', category: 'boxes', alt: 'Box de banheiro clean' },
    
    // Espelhos
    { id: 16, src: '/assets/images/espelho-1.jpg', category: 'espelhos', alt: 'Espelho com LED embutido' },
    { id: 18, src: '/assets/images/espelho-3.jpg', category: 'espelhos', alt: 'Espelho com iluminação LED' },
    { id: 19, src: '/assets/images/espelho-4.jpg', category: 'espelhos', alt: 'Espelho grande com backlight' },
    { id: 20, src: '/assets/images/espelho-5.png', category: 'espelhos', alt: 'Espelho orgânico com iluminação' },
    { id: 23, src: '/assets/images/espelho-6.jpg', category: 'espelhos', alt: 'Espelho grande em sala integrada' },
    { id: 24, src: '/assets/images/espelho-7.jpg', category: 'espelhos', alt: 'Espelho em área gourmet moderna' },
    { id: 25, src: '/assets/images/espelho-8.jpg', category: 'espelhos', alt: 'Espelho de banheiro com moldura lapidada' },
    
    // Portas
    { id: 21, src: '/assets/images/porta-1.jpg', category: 'portas', alt: 'Porta de vidro canelado com perfil preto' },
    { id: 22, src: '/assets/images/porta-2.jpg', category: 'portas', alt: 'Porta jateada para área de serviço' },
  ];

  const filteredImages = selectedCategory === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedCategory);

  return (
    <section id="gallery" className="section-padding bg-[var(--bg-primary)]">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="heading-1 mb-4">Galeria de Projetos</h2>
          <p className="body-regular text-[var(--text-secondary)]">
            Conheça alguns dos nossos trabalhos realizados em Sorocaba
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`px-6 py-3 font-medium transition-all duration-300 ${
                selectedCategory === category.id
                  ? 'bg-[var(--accent-gold)] text-white'
                  : 'bg-white text-[var(--text-primary)] hover:bg-[var(--bg-secondary)]'
              }`}
            >
              {category.label}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {filteredImages.map((image, index) => (
            <div
              key={image.id}
              className="relative group cursor-pointer overflow-hidden hover-lift fade-in"
              style={{ animationDelay: `${index * 0.05}s` }}
              onClick={() => setSelectedImage(image)}
            >
              <div className="aspect-square">
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 flex items-center justify-center">
                <span className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-sm font-medium">
                  Ver imagem
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <p className="body-large text-[var(--text-secondary)] mb-6">
            Gostou do que viu? Solicite um orçamento sem compromisso
          </p>
          <a
            href="https://wa.me/5515991253527?text=Olá!%20Vi%20a%20galeria%20e%20gostaria%20de%20um%20orçamento."
            target="_blank"
            rel="noopener noreferrer"
            className="btn-gold"
          >
            Solicitar Orçamento
          </a>
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-[var(--accent-gold)] transition-colors"
            onClick={() => setSelectedImage(null)}
          >
            <X size={32} />
          </button>
          <img
            src={selectedImage.src}
            alt={selectedImage.alt}
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
};

export default Gallery;
